<template>
  <component
    v-if="component"
    :is="component"
    :value="value"
    @input="updateValue"
    :licenseRendererVm="licenseRendererVm"
  />
</template>

<script>
import camelCase from 'lodash/camelCase';

import AppYourFilm from './AppSpecificLicenseComponent/AppYourFilm';
import AppYourDetails from './AppSpecificLicenseComponent/AppYourDetails';
import AppAdditionalAgreements from './AppSpecificLicenseComponent/AppAdditionalAgreements';
import AppAdditionalAgreementsFastTrack from './AppSpecificLicenseComponent/AppAdditionalAgreementsFastTrack';
import AppYourLicenseRenewalMedia from './AppSpecificLicenseComponent/AppYourLicenseRenewalMedia';
import AppYourLicenseRenewalLabs from './AppSpecificLicenseComponent/AppYourLicenseRenewalLabs';
import AppYourLicenseRenewalMonetization from './AppSpecificLicenseComponent/AppyourLicenseRenewalMonetization';

export default {
  name: 'LicenseAction',
  components: {
    AppYourFilm,
    AppYourDetails,
    AppAdditionalAgreements,
    AppAdditionalAgreementsFastTrack,
    AppYourLicenseRenewalLabs,
    AppYourLicenseRenewalMedia,
    AppYourLicenseRenewalMonetization,
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true,
    },
    licenseWrapper: {
      type: Object,
      required: true,
    },
    licenseItem: {
      type: Object,
      required: true,
    },
    value: {},
  },
  computed: {
    itemType() {
      return this.licenseItem.itemType;
    },
    itemFormName() {
      return this.licenseWrapper.itemFormName;
    },
    componentName() {
      const componentName = this.licenseItem.itemComponent.componentName || '';
      const camelledName = camelCase(componentName);
      const pascalledName = camelledName.charAt(0).toUpperCase() + camelledName.slice(1);
      return pascalledName;
    },
    component() {
      return this.$options.components[this.componentName];
    },
  },
  methods: {
    updateValue(newValue) {
      this.$emit('input', [this.itemFormName, newValue]);
    },
  },
  mounted() {
    const isRequestedComponentRegistered = !!this.component;

    if (!isRequestedComponentRegistered) {
      /* eslint no-console: 0 */
      console.error('The requested component is not available. Make sure creator is running on the latest version.');
    }
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/LicenseComponent.vue